"use strict";

var curry = require("./curry.js");

module.exports = curry(function undefinedTo(a, b) {
  return b === undefined ? a : b;
});